import { ConfirmDialogDetail } from '../../../shared/components/confirm-dialog.component';
import { Utils } from '../../../../shared/utils';

export interface IncomeDocumentSummary {
  receiverName?: string | null;
  total?: number | null;
}

export function documentConfirmDetails(doc: IncomeDocumentSummary): ConfirmDialogDetail[] {
  const details: ConfirmDialogDetail[] = [];
  if (doc.receiverName) details.push({ label: 'Destinatario', value: doc.receiverName });
  if (doc.total != null) details.push({ label: 'Total', value: Utils.FormatMoney(doc.total) + ' €' });
  return details;
}
